// const adminBaseUrl = 'http://admin.regler-sikora.localhost';
// const adminBaseUrl = 'http://regler-sikora-admin.zirkusdigitalo.de';
// const adminBaseUrl = 'https://admin.regler-sikora.de';
// const adminBaseUrl = 'http://web3153.host1555.raghosting.de/admin/';
const adminBaseUrl = 'https://admin.regler-sikora.de/';

export default adminBaseUrl;